export const appBarLinks = [
  {
    label: 'Alumnos/as',
    pathName: 'alumnos',
    roles: ['Educacion'],
  },
  {
    label: 'Aprobaciones',
    pathName: 'aprobaciones',
    roles: ['Educacion'],
  },
  {
    label: 'Lotes',
    pathName: 'role-caja-home',
    roles: ['Caja'],
  },
  {
    label: 'Usuarios',
    pathName: 'admin-bouser-list',
    roles: ['Admin'],
  },
  {
    label: 'Configuración',
    pathName: 'admin-app-settings',
    roles: ['Admin'],
  },
  {
    label: 'Auditoría',
    pathName: 'admin-audit-users',
    roles: ['Admin'],
  },
  {
    label: 'Desbalances',
    pathName: 'admin-unbalances',
    roles: ['Admin'],
  },
  {
    label: 'CBU',
    pathName: 'admin-cbu',
    roles: ['Admin'],
  },
  {
    label: 'SGE',
    pathName: 'admin-sge',
    roles: ['Admin']
  },
  {
    label: 'Funciones',
    pathName: 'admin-functions',
    roles: ['Admin']
  },
  {
    label: 'Reportes',
    pathName: 'role-reportes-home',
    roles: ['Reportes'],
  },
  {
    label: 'Aprobaciones',
    pathName: 'role-oraculo-home',
    roles: ['Oraculo'],
  },
]
